import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { CustomFieldTypePipe } from '../../../pipes/custom-field-type.pipe';

@Component({
  selector: 'app-custom-field-textarea',
  standalone: true,
  templateUrl: './custom-field-textarea.component.html',
  imports: [MatFormField, MatInput, ReactiveFormsModule, MatHint, CdkTextareaAutosize, CustomFieldTypePipe],
  styleUrl: './custom-field-textarea.component.scss'
})
export class CustomFieldTextareaComponent {
  @Input() group: FormGroup | null = null;
  @Input() showHint = false;
}
